import { useEffect, useState, useRef } from "react"
import { get_payments, get_stripe } from '../../../../server/requests'
import Authorize from "./Authorize"
import PayPal from "./PayPal";
import { useRouter } from '../../../../hooks/router'
import ErrorMessage from '../../../AlertMessage/ErrorMessage'
import { decrypt } from "../../../Util/util";

export default function Balance({ appSettings }) {
   
    const router = useRouter()

    const refAmount = useRef(null)

    const [balance, setBalance] = useState(null)
    const [valueAmount, setValueAmount] = useState('')
    const [notValid, setNotValid] = useState(false)
    const [activeIndex, setActiveIndex] = useState(null)
    const [errorMessage, setErrorMessage] = useState({
        show: false,
        text: '',
        type: ''
    })

    useEffect(() => {
        get_payments({}, res => {
            setBalance(res)
        })
    }, [])

    useEffect(() => {
        if (router.query.a == 'balance') {

            if (router.query.message == 'success') {

                setErrorMessage({
                    show: true,
                    text: 'Successfully added balance',
                    type: 'success'
                })

                hideAlertMessage()

            } else if (router.query.message == 'error') {

                setErrorMessage({
                    show: true,
                    text: 'Error adding balance',
                    type: 'error'
                })

                hideAlertMessage()

            }

        }

    }, [router.query])

    const hideAlertMessage = () => {
        setTimeout(() => {

            setErrorMessage({
                ...errorMessage,
                show: false,
            })
            setValueAmount('')
            router.replace('/settings?a=balance')
        }, 3000);

    }

    const onChangeHandler = (e) => {

        if (notValid) setNotValid(false)

        if (!isNaN(e.target.value)) {
            if (activeIndex) setActiveIndex(null)
            setValueAmount(e.target.value)
        }

    }

    const selectMethod = (index) => {

        if (activeIndex == index) index = null

        setActiveIndex(index)

    }

    const addBalanceStripe = () => {
        if (valueAmount.trim() == '') {
            refAmount.current.focus()
            setNotValid(true)
            return
        }

        let _url = `${window._HOST_}/payment/stripe/checkout?type=one_time_payment&price=${valueAmount}&token=${decrypt('token', localStorage.getItem("token")) }`

        window.location.href = _url

    }


    return (
        <>
            <ErrorMessage text={errorMessage.text} type={errorMessage.type} show={errorMessage.show} />

            {balance && appSettings.enable_payment && <div className="main_payments">
                <h1>Add your balance</h1>
                <div className="balance_value">
                    <span className="currency_value">{balance.currency.symbol}</span>
                    <input ref={refAmount} className={notValid ? 'not_valid' : ''} type="text" value={valueAmount} onChange={onChangeHandler} />
                </div>
                <div className="methods_list">
                    {
                        balance && balance.data.map((elem, index) => {
                            return (
                                <div key={index} className={" parent_method_payment " + (activeIndex == index ? "selected" : '')}>
                                    <div className="method_peyment" onClick={() => selectMethod(index)}>
                                        <img src={elem.icon} className="icon_methods" alt="" />
                                        <span className="name_method">{elem.name}</span>
                                    </div>
                                    {elem.name == 'Authorize.net' ?
                                        <div className="drop_down_balance">
                                            <Authorize
                                                amount={valueAmount}
                                                setValue={setValueAmount}
                                                setNotValid={setNotValid}
                                                refAmount={refAmount}
                                                setErrorMessage={setErrorMessage}
                                                errorMessage={errorMessage}
                                            />
                                        </div>
                                        : null}
                                </div>

                            )
                        })
                    }
                </div>
                {
                    balance && activeIndex && balance.data[activeIndex].name !== 'Authorize.net' ?
                        balance && activeIndex && balance.data[activeIndex].name == 'Paypal' ?
                            <PayPal
                                clientId={balance.data[activeIndex].client_id}
                                amount={valueAmount}
                                setValueAmount={setValueAmount}
                                setErrorMessage={setErrorMessage}
                                errorMessage={errorMessage}
                            />
                            :
                            <button className="add_balance_btn" onClick={addBalanceStripe} type={balance.data[activeIndex].name}>ADD</button>

                        : null
                }

            </div>}
        </>


    )
}
